document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.prod-price-container').forEach(function(container) {
    const desconto = container.querySelector('[data-wsjs-product="tagDescount"]');
    const precoAzul = container.querySelector('[data-wsjs-product="priceCash"]');

    if (!desconto || !precoAzul) return;

    if (container.querySelector('.linha-preco-com-desconto')) return;

    const linhaPreco = document.createElement('div');
    linhaPreco.className = 'linha-preco-com-desconto';

    precoAzul.parentNode.insertBefore(linhaPreco, precoAzul);

    linhaPreco.appendChild(precoAzul);
    linhaPreco.appendChild(desconto);
  });
});